import { render } from "./UserWinnings.vue?vue&type=template&id=2e2bbbea&scoped=true"
import script from "./UserWinnings.vue?vue&type=script&lang=js"
export * from "./UserWinnings.vue?vue&type=script&lang=js"

import "./UserWinnings.vue?vue&type=style&index=0&id=2e2bbbea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2bbbea"]])

export default __exports__